import React, { useEffect, useState, useRef, useMemo, useContext } from "react";
import axios from "axios";
import Select from "react-select";
import { useParams, Link } from "react-router-dom";
import config from "../../../config/config";
import Loader from "../../../components/Loader/Loader";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import { CUSTOM_SELECT_DROPDOWN_STYLE } from "../../../common/Constant";
import ReportDate from "../../../components/Reports/ReportDate";
import CommonMatrialReactTable from "../../../components/Datatable/CommonMatrialReactTable";
import CurrencySymbols from "../../../common/CurrencySymbol";
import { AppContext } from "../../../context/AppContext";
import moment from "moment";
import { toastWarn } from "../../../common/Toast";

const RepotsManufacturer = (props) => {
  const token = localStorage.getItem("Token");
  const locationid = localStorage.getItem("Location");
  const { CurrencySymbol, FractionDigits, dateFormate } =
    useContext(AppContext);
  const [responseData, setResponseData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalSum, setTotalSum] = useState(0);
  const [startdate, setStartDate] = useState("");
  const [enddate, setEndDate] = useState("");
  const [selectedDate, setSelectedDate] = useState([]);
  const [selectReport, setSelectReport] = useState(7);
  const [saletype, setSaletype] = useState([]);
  const [selectedSaleTypeId, setSelectedSaleTypeId] = useState(0);
  const ITEMS_PER_PAGE = 10;
  const [locationdropdown, setLocationDropdown] = useState([]);
  const [selectedlocationid, setSelectedLocationID] = useState(
    Number(locationid)
  );
  const [totalData, setTotalData] = useState({
    TotalSum: 0,
    SubTotalSum: 0,
    TaxSum: 0,
    CostOfGoodsSoldSum: 0,
    ProfitSum: 0,
  });

  console.log(startdate, enddate, "checkdates");

  let dashStyle = {
    // width: "280px",
    background: "#fff",
    marginTop: "10px",
    borderRadius: "6px",
    padding: "20px",
    border: "1px solid #E8EBED",
  };

  const [data, setData] = useState({
    inputValue: "",
    width: 1,
    height: 20,
    fontSize: 15,
    zeroFill: 10,
  });

  const handleDropdownChange = (event) => {
    console.log(event, "event123");
    setSelectReport(event?.value);
    if (event?.value == 1) {
      setStartDate("");
      setEndDate("");
    }
  };

  const handleLocationDropdownChange = (event) => {
    setSelectedLocationID(event?.value);
    console.log(event?.value, "Location chnage");
  };

  const handleChangeSalesType = (event) => {
    setSelectedSaleTypeId(event?.value);
  };

  useEffect(() => {
    axios
      .get(`${config.reportsBaseUrl}/reports/reportperioddropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setSelectedDate(res.data.ResponseData);
        setLoading(false);
        return res;
      });

    // Location Dropdown
    axios
      .get(`${config.locationBaseUrl}/locations/locationdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setLocationDropdown(res.data.ResponseData);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(`${config.salesconfigBaseUrl}/sales/saletype`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((response) => {
        setSaletype(response.data.ResponseData);
        console.log(response.data.ResponseData, "===> setSaletype");
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const calculateTotalSum = () => {
    const sum = responseData.reduce((total, report) => {
      const reportTotal = Number(report.Openingbalance);

      if (typeof reportTotal === "number" && !isNaN(reportTotal)) {
        return total + reportTotal;
      } else {
        return total;
      }
    }, 0);

    setTotalSum(sum);
  };
  const RolesDropdown = (event, index) => {
    console.log(event?.label, event?.value, event?.id, "RolesDropdown");
  };

  let reportdropdown = [];
  const data2 = selectedDate.map(
    (u, i) => (reportdropdown[i] = { label: u.Name, value: u.ID })
  );

  const locationDropdownOption = [
    { label: "All", value: 0 }, // Adding "All" option
    ...locationdropdown.map((u) => ({ label: u.Name, value: u.Id })),
  ];

  let salesTypeDropdownOption = [];
  const SalesTypeDropdown = saletype
    .filter((u) => u.ID !== 3) // Exclude items with ID = 3 Estimate
    .map((u, i) => {
      salesTypeDropdownOption[i] = { label: u.SalesType, value: u.ID };
    });

  useEffect(() => {
    calculateTotalSum();
  }, [responseData]);

  const callback = (payload, enddate2) => {
    console.log(selectReport, "selectReportcv");
    if (selectReport === 1) {
      setStartDate("");
      setEndDate("");
    } else {
      setStartDate(payload);
      setEndDate(enddate2);
    }
  };

  const columns = useMemo(() => [
    {
      header: "Manufacturer",
      accessorKey: "manufacturers",
      filterFn: "contains",
    },
    {
      header: "Sub Total",
      accessorKey: "Subtotal",
      Cell: ({ row }) => {
        const Subtotal = row?.original?.Subtotal;
        if (Subtotal == "0.00" || Subtotal == "") {
          return 0.0;
        } else {
          return (
            <div>
              {CurrencySymbols(
                Number(Subtotal),
                { CurrencySymbol },
                FractionDigits
              )}
            </div>
          );
        }
      },
    },
    {
      header: "Total",
      accessorKey: "Total",
      Cell: ({ row }) => {
        const total = row?.original?.Total;
        if (total == "0.00" || total == "") {
          return 0.0;
        } else {
          return (
            <div>
              {CurrencySymbols(
                Number(total),
                { CurrencySymbol },
                FractionDigits
              )}
            </div>
          );
        }
      },
    },
    {
      header: "Tax",
      accessorKey: "Tax",
      Cell: ({ row }) => {
        const tax = row?.original?.Tax;
        if (tax == "0.00" || tax == "") {
          return 0.0;
        } else {
          return (
            <div>
              {CurrencySymbols(Number(tax), { CurrencySymbol }, FractionDigits)}
            </div>
          );
        }
      },
    },
    {
      header: "Profit",
      accessorKey: "Profit",
      Cell: ({ row }) => {
        const profit = row?.original?.Profit;
        if (profit == "0.00" || profit == "") {
          return 0.0;
        } else {
          return (
            <div>
              {CurrencySymbols(
                Number(profit),
                { CurrencySymbol },
                FractionDigits
              )}
            </div>
          );
        }
      },
    },
    // {
    //   header : "Item Variation",
    //   accessorKey : "ItemVariation",
    // },
    {
      header: "Number Of Items Sold",
      accessorKey: "NumberOfItemSoldint",
      filterFn: "contains",
    },
  ]);

  const handleSubmit = () => {
    apicall();
  };

  const apicall = () => {
    setLoading(true);
    setResponseData([]);
    axios
      .get(
        `${config.reportsBaseUrl}/reports/repotsmanufacturers?filtercolumnsearchtext=&currentorder=&ordercolumn=&pagesize=0&pagenumber=0&filtertext=&startdate=${startdate}&enddate=${enddate}&saletypeid=${selectedSaleTypeId}&locationid=${selectedlocationid}&currentlocationid=${locationid}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS") {
          if (res.data.ResponseData.length > 0) {
            const FilterData = res.data.ResponseData?.map((el) => ({
              ...el,
              manufacturers: String(el.manufacturers),
              Profit: Number(el.Profit),
            }));
            setResponseData(FilterData);
            setData(FilterData);
            setTotalData({
              ...totalData,
              TotalSum: res.data.ResponseData[0].TotalSum,
              SubTotalSum: res.data.ResponseData[0].SubTotalSum,
              TaxSum: res.data.ResponseData[0].TaxSum,
              CostOfGoodsSoldSum: res.data.ResponseData[0].CostOfGoodsSoldSum,
              ProfitSum: res.data.ResponseData[0].ProfitSum,
            });
          } else {
            toastWarn("No Records Found!");
          }
        } else {
          setTotalData({
            ...totalData,
            TotalSum: 0,
            SubTotalSum: 0,
            TaxSum: 0,
            CostOfGoodsSoldSum: 0,
            ProfitSum: 0,
          });
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
        return;
      });
  };

  // useEffect(() => {
  //   setLoading(true);
  //   axios
  //     .get(
  //       `${config.reportsBaseUrl}/reports/repotsmanufacturers?filtercolumnsearchtext=&currentorder=&ordercolumn=&pagesize=&pagenumber=&filtertext=&startdate=&enddate=`,
  //       {
  //         headers: {
  //           "Content-Type": "application/json;charset=UTF-8",
  //           "Access-Control-Allow-Origin": "*",
  //           Authorization: token,
  //         },
  //       }
  //     )
  //     .then((res) => {
  //       console.log(res.data.ResponseData, "res======>");
  //       if (res.data.ResponseCode === "SUCCESS") {
  //         const FilterData = res.data.ResponseData?.map((el) => ({
  //           ...el,
  //           manufacturers: String(el.manufacturers),
  //           Profit: Number(el.Profit),
  //         }));
  //         setResponseData(FilterData);
  //         setData(FilterData);
  //         setTotalData({
  //           ...totalData,
  //           TotalSum: res.data.ResponseData[0].TotalSum,
  //           SubTotalSum: res.data.ResponseData[0].SubTotalSum,
  //           TaxSum: res.data.ResponseData[0].TaxSum,
  //           CostOfGoodsSoldSum: res.data.ResponseData[0].CostOfGoodsSoldSum,
  //           ProfitSum: res.data.ResponseData[0].ProfitSum,
  //         });
  //       } else {
  //         setTotalData({
  //           ...totalData,
  //           TotalSum: 0,
  //           SubTotalSum: 0,
  //           TaxSum: 0,
  //           CostOfGoodsSoldSum: 0,
  //           ProfitSum: 0,
  //         });
  //       }
  //       setLoading(false);
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //       setLoading(false);
  //       return;
  //     });
  //   // setLoading(false);
  //   // setIsRefetching(false);
  // }, []);

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              {/* <h3 className="page-title">RepotsManufacturer</h3> */}
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "12px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/reports">Report</Link>
                </li>
                <li className="breadcrumb-item active">Manufacturers Report</li>
              </ul>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-3">
              <label className="col-form-label col-md-12 form-label p-lg-medium">
                Report period
              </label>
              <div className="row">
                <div className="col-md-12 z-3">
                  <Select
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    options={reportdropdown}
                    // defaultValue={selectReport}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    hideSelectedOptions={true}
                    // isClearable={true}
                    name="Reportperiod"
                    id="Reportperiod"
                    value={reportdropdown.find((e) => e.value === selectReport)}
                    onChange={(event) => {
                      handleDropdownChange(event);
                    }}
                    className="custom-search-select"
                  ></Select>
                </div>
              </div>
            </div>
            {selectReport !== 1 && (
              <div className="col-sm-3">
                {/* <div className="row"> */}
                <ReportDate
                  callback={callback}
                  selectReport={selectReport}
                  showhidecomponent={
                    selectReport == 2 ||
                    selectReport == 3 ||
                    selectReport == 4 ||
                    selectReport == 5 ||
                    selectReport == 6 ||
                    selectReport == 7 ||
                    selectReport == 8 ||
                    selectReport == 9 ||
                    selectReport == 10 ||
                    selectReport == 11 ||
                    selectReport == 12 ||
                    selectReport == 13 ||
                    selectReport == 14 ||
                    selectReport == 15 ||
                    selectReport == 16 ||
                    selectReport == 17 ||
                    selectReport == 18 ||
                    selectReport == 19 ||
                    selectReport == 20 ||
                    selectReport == 21 ||
                    selectReport == 22 ||
                    selectReport == 23 ||
                    selectReport == 24 ||
                    selectReport == 25 ||
                    selectReport == 26 ||
                    selectReport == 27 ||
                    selectReport == 28 ||
                    selectReport == 29 ||
                    selectReport == 30 ||
                    selectReport == 31
                      ? true
                      : false
                  }
                />
                {/* </div> */}
              </div>
            )}
            <div className="col-sm-2 ">
              <label className="col-form-label col-md-5 form-label p-lg-medium">
                Sale type
              </label>
              <Select
                onChange={(event) => {
                  handleChangeSalesType(event);
                }}
                value={salesTypeDropdownOption?.find(
                  (el) => el.value == selectedSaleTypeId
                )}
                options={salesTypeDropdownOption}
                backspaceRemovesValue={false}
                controlShouldRenderValue={true}
                isClearable={true}
                styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                className="custom-search-select mt-1"
              />
            </div>
            <div className="col-sm-2">
              <label className="col-form-label col-md-5 form-label p-lg-medium">
                Locations
              </label>
              <div className="col-md-12 z-3">
                <Select
                  styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                  options={locationDropdownOption}
                  backspaceRemovesValue={false}
                  controlShouldRenderValue={true}
                  hideSelectedOptions={true}
                  // isClearable={true}
                  name="location"
                  id="location"
                  value={locationDropdownOption.find(
                    (e) => e.value === selectedlocationid
                  )}
                  onChange={(event) => {
                    handleLocationDropdownChange(event);
                  }}
                  className="custom-search-select"
                ></Select>
              </div>
            </div>
            <div className="col-sm-2 align-self-sm-end">
              <button
                type="submit"
                className="btn btn-primary"
                // style={{ marginLeft: "auto" }}
                onClick={() => apicall()}
              >
                Run Report
              </button>
            </div>
          </div>
          {/* <div className="col-md-1">
              <label className="col-form-label col-md-5 form-label p-lg-medium">
                {""}
              </label>
              <button
                class="btn btn-primary mt-3"
                type="submit"
                onClick={() => handleSubmit()}
              >
                Submit
              </button>
            </div> */}
          {responseData.length > 0 && (
            <>
              <div
                className="row mt-3"
                style={{
                  display: "grid",
                  gap: "1rem",
                  // gridTemplateColumns: "repeat(5,1fr)"
                  gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
                }}
              >
                <div className="cards">
                  <div className="dash-widget" style={dashStyle}>
                    <div className="dash-widgetimg"></div>
                    <div className="dash-widgetcontent">
                      <p className="p-20">
                        {/* ${totalData.SubTotalSum} */}
                        {CurrencySymbols(
                          Number(totalData.SubTotalSum),
                          { CurrencySymbol },
                          FractionDigits
                        )}
                      </p>
                      <div className="d-flex">
                        <p className="p-medium">Subtotal</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="cards">
                  <div className="dash-widget" style={dashStyle}>
                    <div className="dash-widgetimg"></div>
                    <div className="dash-widgetcontent">
                      <p className="p-20">
                        {/* ${totalData.TotalSum} */}
                        {CurrencySymbols(
                          Number(totalData.TotalSum),
                          { CurrencySymbol },
                          FractionDigits
                        )}
                      </p>
                      <div className="d-flex">
                        <p className="p-medium">Total</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="cards">
                  <div className="dash-widget" style={dashStyle}>
                    <div className="dash-widgetimg"></div>
                    <div className="dash-widgetcontent">
                      <p className="p-20">
                        {/* ${totalData.TaxSum} */}
                        {CurrencySymbols(
                          Number(totalData.TaxSum),
                          { CurrencySymbol },
                          FractionDigits
                        )}
                      </p>
                      <div className="d-flex">
                        <p className="p-medium">Tax</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="cards">
                  <div className="dash-widget" style={dashStyle}>
                    <div className="dash-widgetimg"></div>
                    <div className="dash-widgetcontent">
                      <p className="p-20">
                        {/* ${totalData.ProfitSum} */}
                        {CurrencySymbols(
                          Number(totalData.ProfitSum),
                          { CurrencySymbol },
                          FractionDigits
                        )}
                      </p>
                      <div className="d-flex">
                        <p className="p-medium">Profit</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card mt-3" id="print">
                <div className="card-body">
                  <div className="container">
                    <div className="col-md-12 text-center" id="header">
                      <h6 className="P">Sonar Pos</h6>
                      <p className="fw-bold p-regular">Manufacturers Report</p>
                      <div className="row">
                        <p>
                          Date:{" "}
                          {startdate === "" && enddate === ""
                            ? "All Data"
                            : moment(startdate).format(
                                `${dateFormate.toUpperCase()}`
                              ) +
                              " - " +
                              moment(enddate).format(
                                `${dateFormate.toUpperCase()}`
                              )}
                        </p>
                      </div>
                    </div>
                  </div>
                  <hr />
                  <div>
                    <CommonMatrialReactTable
                      MainHeading="Sonar POS"
                      ReportHeading="Manufacturers Report"
                      columns={columns}
                      data={responseData}
                      startdate={startdate}
                      enddate={enddate}
                      columnGrouping={[]}
                      columnsVisibility={{}}
                      enableRowSelection={false}
                    />
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default RepotsManufacturer;
